import { ref } from 'vue';

const storageKey = 'jobifull.session-expired.v1';

function storedNotice() {
  try { return window.sessionStorage.getItem(storageKey) === '1'; }
  catch (_) { return false; }
}

export const sessionExpiryNotice = ref(storedNotice());

export function markSessionExpired() {
  sessionExpiryNotice.value = true;
  try { window.sessionStorage.setItem(storageKey, '1'); }
  catch (_) { /* The current page still shows the notice when storage is blocked. */ }
}

export function clearSessionExpiryNotice() {
  sessionExpiryNotice.value = false;
  try { window.sessionStorage.removeItem(storageKey); }
  catch (_) { /* No credentials or account data are stored by this notice. */ }
}
